// clearIndicator
// container
// control
// dropdownIndicator
// group
// groupHeading
// indicatorsContainer
// indicatorSeparator
// input
// loadingIndicator
// loadingMessage
// menu
// menuList
// menuPortal
// multiValue
// multiValueLabel
// multiValueRemove
// noOptionsMessage
// option
// placeholder
// singleValue
// valueContainer

const selectStyles = {
    valueContainer: (provided, state) => ({
        ...provided,
        height: '56px'

    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: '25px',
        overflow: 'hidden',
    }),
    container: (provided, state) => ({
        ...provided,

        flex: '1 1 auto'
    }),
    multiValue: (provided, state) => ({
        ...provided,
        borderRadius: '15px'
    })
};
export default selectStyles;